<template>
  <thead class="mainTableAllBack_thead">
    <tr>
      <th class="th" v-if="isIndexNumber">
        <div class="theadText nowrap">#</div>
      </th>
      <th
        v-for="(item, index) in headers"
        :key="index"
        class="th"
        :class="[
          item.value,
          {
            'filter-active':
              filterClasses[item.valueFilter] ||
              filterClassesActive(item.value),
          },
          { lastTh: item.sticky },
        ]"
      >
        <field
            v-if="item.isCheckboxAll"
            margin="0"
            padding="0"
            height="24"
            :switch-value="checkAll"
            @updateSwitch="onCheckboxAll"
            is-dense
            is-checkbox
            :indeterminate="indeterminate"
            is-off-style
            :is-disabled="isCheckboxDisabled(!list.length)"
        ></field>
<!--	      :is-disabled="!list.length"-->
        <div v-else class="controls" :class="['child_icon', item.childElements, {'flexJc': item.flexJc}]">
          <template v-if="item.childElements">
            <div class="childIcon">
              <svg-sprite width="16" height="16" icon-id="structure"></svg-sprite>
            </div>
          </template>
          <template v-else>
            <sort-btn
              v-if="item.sortable"
              :sortDesc="sortDesc"
              :sortBy="sortBy"
              :data-sort="item.valueFilter"
              @updateToggleOrder="toggleOrder"
            ></sort-btn>
            <div class="theadText" :class="[{ nowrap: item.nowrap }]">
              {{ item.text }}
            </div>
            <filter-drop-down v-if="item.func" :item="item">
              <filter-table
                @change-sort="changeSort"
                @create-refresh="createRefresh"
                @filter-created="filterCreated"
                @updatePerLoad="onPerLoad"
                @updateFilterListAll="onFilteredAll(item.valueFilter)"
                :flag="flag"
                :filtersList="filtersList"
                :data-filter="filtersList[item.valueFilter]"
                :defaultFilter="defaultFilter"
                :selectedAllElements="selectedAllElements"
                :item="item"
                :model-filter="item.valueFilter"
                :type-filter="item.model"
                :filter-update="isFilterUpdate"
                :refreshDate="isRefreshDate"
                :labelFilter="item.text"
                :isDisabled="isDisabled"
                :is-disabled="!!isRefresh"
                :isRefresh="isRefresh"
                :externalValue="getExternalValue(item.valueFilter)"
              ></filter-table>
            </filter-drop-down>
          </template>
        </div>
      </th>
    </tr>
  </thead>
</template>

<script>
// components
import FilterTable from "@/shared/FilterTable/FilterTable";
import SortBtn from "@/shared/SortBtn/SortBtn";
import FilterDropDown from "@/shared/FilterDropDown/FilterDropDown";
import { PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import { mapGetters } from "vuex";

export default {
	name: "Thead",
	components: {
		FilterDropDown,
		FilterTable,
		SortBtn,
	},
	computed: {
		...mapGetters([ 'permissionsDefault' ]),
	},
	props: {
		checkAll: Boolean,
		indeterminate: Boolean,
		flag: String,
		headers: Array,
		list: Array,
		filtersList: Object,
		selectedAllElements: Object,
		defaultFilter: Object,
		isRefresh: String,
		isFilterUpdate: Boolean,
		isRefreshDate: String,
		isIndexNumber: Boolean,
		isDisabled: Boolean,
		sortDesc: Boolean,
		sortBy: String,
		filterClasses: Object,
		filterMod: {
			type: Object,
			default: function() {
				return {};
			},
		},
	},
	methods: {
		/**
		 * Повертає поточне вибране значення для конкретного фільтра,
		 * щоб FilterTable міг показати його при відкритті (через externalValue).
		 *
		 * @param {string} key - valueFilter з headers (наприклад "filter_customer")
		 * @returns {*|null} Значення з filterMod або null
		 */
		getExternalValue(key) {
			if (!this.filterMod) return null;
			if (!Object.prototype.hasOwnProperty.call(this.filterMod, key)) return null;
			return this.filterMod[key];
		},
		isCheckboxDisabled(args) {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.CUSTOMER_INVOICES, PERMISSIONS.SEND ];
			const perm = getPermissionsMod({ list, path });

			if (!perm) return true;
			
			return args;
		},
		onCheckboxAll({ value }) {
			this.$emit('updateCheckOrders', value);
		},
		filterClassesActive(filterKey) {
			const {
				filter_check_in_empty,
				filter_check_out_empty,
				filter_rout_city,
				filter_rout_state,
			} = this.filterClasses || {};
			return (
				(filterKey === "check_in" && filter_check_in_empty) ||
        (filterKey === "check_out" && filter_check_out_empty) ||
        (filterKey === "routs" && filter_rout_city) ||
        (filterKey === "routs" && filter_rout_state)
			);
		},
		toggleOrder(val) {
			const { valueFilter } = this.headers.find(
				(item) => item.valueFilter === val
			);
			this.$emit("updateChangeSorting", {
				sortBy: valueFilter,
				sortDesc: !this.sortDesc,
			});
		},
		changeSort(value) {
			this.$emit("updateChangeSort", value);
		},
		createRefresh(value) {
			this.$emit("updateCreateRefresh", value);
		},
		filterCreated(value) {
			this.$emit("updateFilterCreated", value);
		},
		onFilteredAll(value) {
			this.$emit("updateFilteredAll", value);
		},
		onPerLoad(value) {
			this.$emit("updatePerLoad", value);
		},
	},
};
</script>

<style lang="scss" scoped>
  .flexJc {
    display: flex !important;
    justify-content: space-between;
  }
</style>
